import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=f0212da0&scoped=true&"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordForm.vue?vue&type=style&index=0&id=f0212da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0212da0",
  null
  
)

export default component.exports